/**
 * Mock data pre funkcionárov (officials)
 */

import { v4 as uuid } from "uuid";

// Pomocné ID pre referencie
const ovmIds = {
  ministerstvo: "ovm-001-ministerstvo-financi",
  mestoPraha: "ovm-002-mesto-praha",
  senat: "ovm-003-senat-cr",
  snemovna: "ovm-004-poslanecka-snemovna",
  krajBrno: "ovm-005-jihomoravsky-kraj",
  mestoBrno: "ovm-006-mesto-brno",
  obecRoztoky: "ovm-007-obec-roztoky",
  ministerstvoPrace: "ovm-008-ministerstvo-prace",
};

const countryIds = {
  czechRepublic: "country-001-cz",
  slovakia: "country-002-sk",
};

const municipalityIds = {
  praha: "muni-001-praha",
  brno: "muni-002-brno",
  ostrava: "muni-003-ostrava",
  plzen: "muni-004-plzen",
  liberec: "muni-005-liberec",
  roztoky: "muni-006-roztoky",
};

// Generátor dátumov
const generateDate = (yearsAgo, monthOffset = 0) => {
  const date = new Date();
  date.setFullYear(date.getFullYear() - yearsAgo);
  date.setMonth(date.getMonth() + monthOffset);
  return date.toISOString();
};

const generateBirthDate = (age) => {
  const date = new Date();
  date.setFullYear(date.getFullYear() - age);
  date.setMonth(Math.floor(Math.random() * 12));
  date.setDate(Math.floor(Math.random() * 28) + 1);
  return date.toISOString().split("T")[0] + "T00:00:00.000Z";
};

export const officials = [
  {
    id: "official-001",
    firstName: "Jan",
    middleName: "",
    lastName: "Novák",
    titleBefore: "Ing.",
    titleAfter: "Ph.D.",
    birthDate: generateBirthDate(52),
    email: "jan.novak@email.cz",
    databox: "abc123xy",
    username: "jnovak",
    active: true,
    checked: true,
    checkedISZR: true,
    visibility: "PUBLIC",
    wpVisibility: "Veřejné",
    created: generateDate(3),
    dateOfEnd: null,
    lastStatementDate: generateDate(0, -2),
    appealDate: null,
    ovmName: "Ministerstvo financí",
    archived: [],
    judge: false,
    isMy: true,
    canGeneratePassword: true,
    canDisplayCredentials: true,
    deputyOrSenator: false,
    promiseDocumented: false,
    concatenatedWorkingPositions: "Náměstek ministra",
    concatenatedWorkingPositionOrganizations: "Ministerstvo financí",
    concatenatedWorkingPositionDates: "01.01.2022 - dosud",
    birthAddress: {
      country: { id: countryIds.czechRepublic, name: "Česká republika" },
      municipality: { id: municipalityIds.praha, name: "Praha" },
      municipalityId: municipalityIds.praha,
      street: "Národní",
      orientationNumber: "15",
      zip: "11000",
    },
    deliveryAddress: {
      country: { id: countryIds.czechRepublic, name: "Česká republika" },
      municipality: { id: municipalityIds.praha, name: "Praha" },
      municipalityId: municipalityIds.praha,
      street: "Letenská",
      orientationNumber: "525/15",
      zip: "11800",
    },
    permanentAddress: {
      country: { id: countryIds.czechRepublic, name: "Česká republika" },
      municipality: { id: municipalityIds.praha, name: "Praha" },
      municipalityId: municipalityIds.praha,
      street: "Vinohradská",
      orientationNumber: "48",
      zip: "12000",
      orp: "Praha",
    },
    permanentAddressUpdateDate: generateDate(0, -6),
    deathDate: null,
    workingPositions: [
      {
        id: "wp-001-001",
        ovmId: ovmIds.ministerstvo,
        created: generateDate(2),
        workingPosition: {
          id: "position-001",
          name: "Náměstek ministra",
          organization: {
            id: ovmIds.ministerstvo,
            name: "Ministerstvo financí",
          },
        },
        fromDate: "2022-01-01T00:00:00.000Z",
        toDate: null,
        visibility: "PUBLIC",
      },
    ],
    statements: [
      {
        id: "stmt-001-001",
        type: "INGOING",
        state: "ACCEPT",
        creationDate: generateDate(2),
      },
      {
        id: "stmt-001-002",
        type: "ONGOING",
        state: "ACCEPT",
        creationDate: generateDate(1),
      },
      {
        id: "stmt-001-003",
        type: "ONGOING",
        state: "NEW",
        creationDate: generateDate(0, -1),
      },
    ],
    ovms: [{ id: ovmIds.ministerstvo, name: "Ministerstvo financí" }],
    settings: {
      mainOvm: { id: ovmIds.ministerstvo, name: "Ministerstvo financí" },
      mainOvmName: "Ministerstvo financí",
    },
  },
  {
    id: "official-002",
    firstName: "Marie",
    middleName: "",
    lastName: "Svobodová",
    titleBefore: "JUDr.",
    titleAfter: "",
    birthDate: generateBirthDate(48),
    email: "marie.svobodova@senat.cz",
    databox: "def456zw",
    username: "msvobodova",
    active: true,
    checked: true,
    checkedISZR: true,
    visibility: "PUBLIC",
    wpVisibility: "Veřejné",
    created: generateDate(5),
    dateOfEnd: null,
    lastStatementDate: generateDate(0, -1),
    appealDate: null,
    ovmName: "Senát ČR",
    archived: [],
    judge: false,
    isMy: true,
    canGeneratePassword: true,
    canDisplayCredentials: true,
    deputyOrSenator: true,
    promiseDocumented: true,
    senator: true,
    senatorAndOthers: false,
    concatenatedWorkingPositions: "Senátorka",
    concatenatedWorkingPositionOrganizations: "Senát ČR",
    concatenatedWorkingPositionDates: "01.11.2018 - dosud",
    birthAddress: {
      country: { id: countryIds.czechRepublic, name: "Česká republika" },
      municipality: { id: municipalityIds.brno, name: "Brno" },
      municipalityId: municipalityIds.brno,
      street: "Masarykova",
      orientationNumber: "22",
      zip: "60200",
    },
    deliveryAddress: {
      country: { id: countryIds.czechRepublic, name: "Česká republika" },
      municipality: { id: municipalityIds.praha, name: "Praha" },
      municipalityId: municipalityIds.praha,
      street: "Valdštejnské náměstí",
      orientationNumber: "17/4",
      zip: "11800",
    },
    permanentAddress: {
      country: { id: countryIds.czechRepublic, name: "Česká republika" },
      municipality: { id: municipalityIds.brno, name: "Brno" },
      municipalityId: municipalityIds.brno,
      street: "Údolní",
      orientationNumber: "33",
      zip: "60200",
      orp: "Brno",
    },
    permanentAddressUpdateDate: generateDate(0, -3),
    deathDate: null,
    workingPositions: [
      {
        id: "wp-002-001",
        ovmId: ovmIds.senat,
        created: generateDate(5),
        workingPosition: {
          id: "position-002",
          name: "Senátorka",
          organization: { id: ovmIds.senat, name: "Senát ČR" },
        },
        fromDate: "2018-11-01T00:00:00.000Z",
        toDate: null,
        visibility: "PUBLIC",
      },
    ],
    statements: [
      {
        id: "stmt-002-001",
        type: "INGOING",
        state: "ACCEPT",
        creationDate: generateDate(5),
      },
      {
        id: "stmt-002-002",
        type: "ONGOING",
        state: "ACCEPT",
        creationDate: generateDate(4),
      },
      {
        id: "stmt-002-003",
        type: "ONGOING",
        state: "ACCEPT",
        creationDate: generateDate(3),
      },
      {
        id: "stmt-002-004",
        type: "ONGOING",
        state: "ACCEPT",
        creationDate: generateDate(2),
      },
      {
        id: "stmt-002-005",
        type: "ONGOING",
        state: "ACCEPT",
        creationDate: generateDate(1),
      },
    ],
    ovms: [{ id: ovmIds.senat, name: "Senát ČR" }],
    settings: {
      mainOvm: { id: ovmIds.senat, name: "Senát ČR" },
      mainOvmName: "Senát ČR",
    },
  },
  {
    id: "official-003",
    firstName: "Petr",
    middleName: "Karel",
    lastName: "Dvořák",
    titleBefore: "Mgr.",
    titleAfter: "",
    birthDate: generateBirthDate(45),
    email: "petr.dvorak@praha.eu",
    databox: "ghi789uv",
    username: "pdvorak",
    active: true,
    checked: true,
    checkedISZR: true,
    visibility: "REQUEST",
    wpVisibility: "Na žádost",
    created: generateDate(4),
    dateOfEnd: null,
    lastStatementDate: generateDate(0, -3),
    appealDate: generateDate(0, -6),
    ovmName: "Magistrát hl. m. Prahy",
    archived: [],
    judge: false,
    isMy: false,
    canGeneratePassword: true,
    canDisplayCredentials: true,
    deputyOrSenator: false,
    promiseDocumented: false,
    concatenatedWorkingPositions: "Radní pro dopravu",
    concatenatedWorkingPositionOrganizations: "Magistrát hl. m. Prahy",
    concatenatedWorkingPositionDates: "15.11.2022 - dosud",
    birthAddress: {
      country: { id: countryIds.czechRepublic, name: "Česká republika" },
      municipality: { id: municipalityIds.plzen, name: "Plzeň" },
      municipalityId: municipalityIds.plzen,
      street: "Americká",
      orientationNumber: "8",
      zip: "30100",
    },
    deliveryAddress: {
      country: { id: countryIds.czechRepublic, name: "Česká republika" },
      municipality: { id: municipalityIds.praha, name: "Praha" },
      municipalityId: municipalityIds.praha,
      street: "Mariánské náměstí",
      orientationNumber: "2/2",
      zip: "11001",
    },
    permanentAddress: {
      country: { id: countryIds.czechRepublic, name: "Česká republika" },
      municipality: { id: municipalityIds.praha, name: "Praha" },
      municipalityId: municipalityIds.praha,
      street: "Karlova",
      orientationNumber: "1",
      zip: "11000",
      orp: "Praha",
    },
    permanentAddressUpdateDate: generateDate(1),
    deathDate: null,
    workingPositions: [
      {
        id: "wp-003-001",
        ovmId: ovmIds.mestoPraha,
        created: generateDate(1, 2),
        workingPosition: {
          id: "position-003",
          name: "Radní pro dopravu",
          organization: {
            id: ovmIds.mestoPraha,
            name: "Magistrát hl. m. Prahy",
          },
        },
        fromDate: "2022-11-15T00:00:00.000Z",
        toDate: null,
        visibility: "REQUEST",
      },
    ],
    statements: [
      {
        id: "stmt-003-001",
        type: "INGOING",
        state: "ACCEPT",
        creationDate: generateDate(1, 2),
      },
      {
        id: "stmt-003-002",
        type: "ONGOING",
        state: "ACCEPT",
        creationDate: generateDate(0, -3),
      },
    ],
    ovms: [{ id: ovmIds.mestoPraha, name: "Magistrát hl. m. Prahy" }],
    settings: {
      mainOvm: { id: ovmIds.mestoPraha, name: "Magistrát hl. m. Prahy" },
      mainOvmName: "Magistrát hl. m. Prahy",
    },
  },
  {
    id: "official-004",
    firstName: "Eva",
    middleName: "",
    lastName: "Černá",
    titleBefore: "Ing.",
    titleAfter: "MBA",
    birthDate: generateBirthDate(39),
    email: "eva.cerna@psp.cz",
    databox: "jkl012st",
    username: "ecerna",
    active: true,
    checked: true,
    checkedISZR: true,
    visibility: "PUBLIC",
    wpVisibility: "Veřejné",
    created: generateDate(2),
    dateOfEnd: null,
    lastStatementDate: generateDate(0, -1),
    appealDate: null,
    ovmName: "Poslanecká sněmovna",
    archived: [],
    judge: false,
    isMy: true,
    canGeneratePassword: true,
    canDisplayCredentials: true,
    deputyOrSenator: true,
    deputy: true,
    deputyAndOthers: false,
    promiseDocumented: false,
    concatenatedWorkingPositions: "Poslankyně",
    concatenatedWorkingPositionOrganizations: "Poslanecká sněmovna",
    concatenatedWorkingPositionDates: "08.11.2021 - dosud",
    birthAddress: {
      country: { id: countryIds.czechRepublic, name: "Česká republika" },
      municipality: { id: municipalityIds.ostrava, name: "Ostrava" },
      municipalityId: municipalityIds.ostrava,
      street: "Nádražní",
      orientationNumber: "100",
      zip: "70200",
    },
    deliveryAddress: {
      country: { id: countryIds.czechRepublic, name: "Česká republika" },
      municipality: { id: municipalityIds.praha, name: "Praha" },
      municipalityId: municipalityIds.praha,
      street: "Sněmovní",
      orientationNumber: "176/4",
      zip: "11800",
    },
    permanentAddress: {
      country: { id: countryIds.czechRepublic, name: "Česká republika" },
      municipality: { id: municipalityIds.ostrava, name: "Ostrava" },
      municipalityId: municipalityIds.ostrava,
      street: "Porážková",
      orientationNumber: "25",
      zip: "70200",
      orp: "Ostrava",
    },
    permanentAddressUpdateDate: generateDate(0, -2),
    deathDate: null,
    workingPositions: [
      {
        id: "wp-004-001",
        ovmId: ovmIds.snemovna,
        created: generateDate(2, 2),
        workingPosition: {
          id: "position-004",
          name: "Poslankyně",
          organization: { id: ovmIds.snemovna, name: "Poslanecká sněmovna" },
        },
        fromDate: "2021-11-08T00:00:00.000Z",
        toDate: null,
        visibility: "PUBLIC",
      },
    ],
    statements: [
      {
        id: "stmt-004-001",
        type: "INGOING",
        state: "ACCEPT",
        creationDate: generateDate(2, 2),
      },
      {
        id: "stmt-004-002",
        type: "ONGOING",
        state: "ACCEPT",
        creationDate: generateDate(1),
      },
      {
        id: "stmt-004-003",
        type: "ONGOING",
        state: "NEW",
        creationDate: generateDate(0, -1),
      },
    ],
    ovms: [{ id: ovmIds.snemovna, name: "Poslanecká sněmovna" }],
    settings: {
      mainOvm: { id: ovmIds.snemovna, name: "Poslanecká sněmovna" },
      mainOvmName: "Poslanecká sněmovna",
    },
  },
  {
    id: "official-005",
    firstName: "Tomáš",
    middleName: "",
    lastName: "Procházka",
    titleBefore: "MUDr.",
    titleAfter: "",
    birthDate: generateBirthDate(55),
    email: "tomas.prochazka@brno.cz",
    databox: "mno345qr",
    username: "tprochazka",
    active: true,
    checked: false,
    checkedISZR: false,
    visibility: "REQUEST",
    wpVisibility: "Na žádost",
    created: generateDate(6),
    dateOfEnd: null,
    lastStatementDate: generateDate(0, -4),
    appealDate: null,
    ovmName: "Statutární město Brno",
    archived: [],
    judge: false,
    isMy: true,
    canGeneratePassword: true,
    canDisplayCredentials: true,
    deputyOrSenator: false,
    promiseDocumented: false,
    concatenatedWorkingPositions: "Primátor",
    concatenatedWorkingPositionOrganizations: "Statutární město Brno",
    concatenatedWorkingPositionDates: "01.11.2018 - dosud",
    birthAddress: {
      country: { id: countryIds.czechRepublic, name: "Česká republika" },
      municipality: { id: municipalityIds.brno, name: "Brno" },
      municipalityId: municipalityIds.brno,
      street: "Kounicova",
      orientationNumber: "67",
      zip: "60200",
    },
    deliveryAddress: {
      country: { id: countryIds.czechRepublic, name: "Česká republika" },
      municipality: { id: municipalityIds.brno, name: "Brno" },
      municipalityId: municipalityIds.brno,
      street: "Dominikánské náměstí",
      orientationNumber: "196/1",
      zip: "60167",
    },
    permanentAddress: {
      country: { id: countryIds.czechRepublic, name: "Česká republika" },
      municipality: { id: municipalityIds.brno, name: "Brno" },
      municipalityId: municipalityIds.brno,
      street: "Lidická",
      orientationNumber: "18",
      zip: "60200",
      orp: "Brno",
    },
    permanentAddressUpdateDate: generateDate(2),
    deathDate: null,
    workingPositions: [
      {
        id: "wp-005-001",
        ovmId: ovmIds.mestoBrno,
        created: generateDate(6),
        workingPosition: {
          id: "position-005",
          name: "Primátor",
          organization: { id: ovmIds.mestoBrno, name: "Statutární město Brno" },
        },
        fromDate: "2018-11-01T00:00:00.000Z",
        toDate: null,
        visibility: "REQUEST",
      },
    ],
    statements: [
      {
        id: "stmt-005-001",
        type: "INGOING",
        state: "ACCEPT",
        creationDate: generateDate(6),
      },
      {
        id: "stmt-005-002",
        type: "ONGOING",
        state: "ACCEPT",
        creationDate: generateDate(5),
      },
      {
        id: "stmt-005-003",
        type: "ONGOING",
        state: "ACCEPT",
        creationDate: generateDate(4),
      },
      {
        id: "stmt-005-004",
        type: "ONGOING",
        state: "ACCEPT",
        creationDate: generateDate(3),
      },
      {
        id: "stmt-005-005",
        type: "ONGOING",
        state: "ACCEPT",
        creationDate: generateDate(2),
      },
      {
        id: "stmt-005-006",
        type: "ONGOING",
        state: "ACCEPT",
        creationDate: generateDate(1),
      },
    ],
    ovms: [{ id: ovmIds.mestoBrno, name: "Statutární město Brno" }],
    settings: {
      mainOvm: { id: ovmIds.mestoBrno, name: "Statutární město Brno" },
      mainOvmName: "Statutární město Brno",
    },
  },
  {
    id: "official-006",
    firstName: "Lucie",
    middleName: "",
    lastName: "Veselá",
    titleBefore: "",
    titleAfter: "",
    birthDate: generateBirthDate(35),
    email: "lucie.vesela@roztoky.cz",
    databox: "pqr678no",
    username: "lvesela",
    active: true,
    checked: true,
    checkedISZR: true,
    visibility: "PUBLIC",
    wpVisibility: "Veřejné",
    created: generateDate(2),
    dateOfEnd: null,
    lastStatementDate: generateDate(0, -2),
    appealDate: null,
    ovmName: "Obec Roztoky",
    archived: [],
    judge: false,
    isMy: true,
    canGeneratePassword: true,
    canDisplayCredentials: true,
    deputyOrSenator: false,
    promiseDocumented: false,
    concatenatedWorkingPositions: "Starostka",
    concatenatedWorkingPositionOrganizations: "Obec Roztoky",
    concatenatedWorkingPositionDates: "20.10.2022 - dosud",
    birthAddress: {
      country: { id: countryIds.czechRepublic, name: "Česká republika" },
      municipality: { id: municipalityIds.roztoky, name: "Roztoky" },
      municipalityId: municipalityIds.roztoky,
      street: "Nádražní",
      orientationNumber: "5",
      zip: "25263",
    },
    deliveryAddress: {
      country: { id: countryIds.czechRepublic, name: "Česká republika" },
      municipality: { id: municipalityIds.roztoky, name: "Roztoky" },
      municipalityId: municipalityIds.roztoky,
      street: "Masarykova",
      orientationNumber: "1/1",
      zip: "25263",
    },
    permanentAddress: {
      country: { id: countryIds.czechRepublic, name: "Česká republika" },
      municipality: { id: municipalityIds.roztoky, name: "Roztoky" },
      municipalityId: municipalityIds.roztoky,
      street: "Příčná",
      orientationNumber: "12",
      zip: "25263",
      orp: "Černošice",
    },
    permanentAddressUpdateDate: generateDate(0, -1),
    deathDate: null,
    workingPositions: [
      {
        id: "wp-006-001",
        ovmId: ovmIds.obecRoztoky,
        created: generateDate(2),
        workingPosition: {
          id: "position-006",
          name: "Starostka",
          organization: { id: ovmIds.obecRoztoky, name: "Obec Roztoky" },
        },
        fromDate: "2022-10-20T00:00:00.000Z",
        toDate: null,
        visibility: "PUBLIC",
      },
    ],
    statements: [
      {
        id: "stmt-006-001",
        type: "INGOING",
        state: "ACCEPT",
        creationDate: generateDate(2),
      },
      {
        id: "stmt-006-002",
        type: "ONGOING",
        state: "NEW",
        creationDate: generateDate(0, -2),
      },
    ],
    ovms: [{ id: ovmIds.obecRoztoky, name: "Obec Roztoky" }],
    settings: {
      mainOvm: { id: ovmIds.obecRoztoky, name: "Obec Roztoky" },
      mainOvmName: "Obec Roztoky",
    },
  },
  {
    id: "official-007",
    firstName: "Karel",
    middleName: "",
    lastName: "Malý",
    titleBefore: "Ing.",
    titleAfter: "",
    birthDate: generateBirthDate(62),
    email: "karel.maly@kraj-jm.cz",
    databox: "stu901lm",
    username: "kmaly",
    active: false,
    checked: true,
    checkedISZR: true,
    visibility: "PUBLIC",
    wpVisibility: "Veřejné",
    created: generateDate(8),
    dateOfEnd: generateDate(0, -6),
    lastStatementDate: generateDate(0, -7),
    appealDate: null,
    ovmName: "Jihomoravský kraj",
    archived: [],
    judge: false,
    isMy: true,
    canGeneratePassword: false,
    canDisplayCredentials: true,
    deputyOrSenator: false,
    promiseDocumented: false,
    concatenatedWorkingPositions: "Hejtman",
    concatenatedWorkingPositionOrganizations: "Jihomoravský kraj",
    concatenatedWorkingPositionDates: "01.11.2016 - 30.06.2025",
    birthAddress: {
      country: { id: countryIds.czechRepublic, name: "Česká republika" },
      municipality: { id: municipalityIds.brno, name: "Brno" },
      municipalityId: municipalityIds.brno,
      street: "Štefánikova",
      orientationNumber: "3",
      zip: "60200",
    },
    deliveryAddress: {
      country: { id: countryIds.czechRepublic, name: "Česká republika" },
      municipality: { id: municipalityIds.brno, name: "Brno" },
      municipalityId: municipalityIds.brno,
      street: "Žerotínovo náměstí",
      orientationNumber: "449/3",
      zip: "60182",
    },
    permanentAddress: {
      country: { id: countryIds.czechRepublic, name: "Česká republika" },
      municipality: { id: municipalityIds.brno, name: "Brno" },
      municipalityId: municipalityIds.brno,
      street: "Botanická",
      orientationNumber: "44",
      zip: "60200",
      orp: "Brno",
    },
    permanentAddressUpdateDate: generateDate(1),
    deathDate: null,
    workingPositions: [
      {
        id: "wp-007-001",
        ovmId: ovmIds.krajBrno,
        created: generateDate(8),
        workingPosition: {
          id: "position-007",
          name: "Hejtman",
          organization: { id: ovmIds.krajBrno, name: "Jihomoravský kraj" },
        },
        fromDate: "2016-11-01T00:00:00.000Z",
        toDate: "2025-06-30T00:00:00.000Z",
        visibility: "PUBLIC",
      },
    ],
    statements: [
      {
        id: "stmt-007-001",
        type: "INGOING",
        state: "ACCEPT",
        creationDate: generateDate(8),
      },
      {
        id: "stmt-007-002",
        type: "ONGOING",
        state: "ACCEPT",
        creationDate: generateDate(7),
      },
      {
        id: "stmt-007-003",
        type: "ONGOING",
        state: "ACCEPT",
        creationDate: generateDate(6),
      },
      {
        id: "stmt-007-004",
        type: "ONGOING",
        state: "ACCEPT",
        creationDate: generateDate(5),
      },
      {
        id: "stmt-007-005",
        type: "ONGOING",
        state: "ACCEPT",
        creationDate: generateDate(4),
      },
      {
        id: "stmt-007-006",
        type: "ONGOING",
        state: "ACCEPT",
        creationDate: generateDate(3),
      },
      {
        id: "stmt-007-007",
        type: "ONGOING",
        state: "ACCEPT",
        creationDate: generateDate(2),
      },
      {
        id: "stmt-007-008",
        type: "ONGOING",
        state: "ACCEPT",
        creationDate: generateDate(1),
      },
      {
        id: "stmt-007-009",
        type: "OUTGOING",
        state: "ACCEPT",
        creationDate: generateDate(0, -7),
      },
    ],
    ovms: [{ id: ovmIds.krajBrno, name: "Jihomoravský kraj" }],
    settings: {
      mainOvm: { id: ovmIds.krajBrno, name: "Jihomoravský kraj" },
      mainOvmName: "Jihomoravský kraj",
    },
  },
  {
    id: "official-008",
    firstName: "Alena",
    middleName: "",
    lastName: "Krejčí",
    titleBefore: "PhDr.",
    titleAfter: "",
    birthDate: generateBirthDate(44),
    email: "alena.krejci@mpsv.cz",
    databox: "vwx234jk",
    username: "akrejci",
    active: true,
    checked: true,
    checkedISZR: true,
    visibility: "SECRET",
    wpVisibility: "Tajné",
    created: generateDate(3),
    dateOfEnd: null,
    lastStatementDate: generateDate(0, -1),
    appealDate: null,
    ovmName: "Ministerstvo práce a sociálních věcí",
    archived: [],
    judge: false,
    isMy: true,
    canGeneratePassword: true,
    canDisplayCredentials: true,
    deputyOrSenator: false,
    promiseDocumented: false,
    concatenatedWorkingPositions: "Náměstkyně ministra",
    concatenatedWorkingPositionOrganizations:
      "Ministerstvo práce a sociálních věcí",
    concatenatedWorkingPositionDates: "01.03.2022 - dosud",
    birthAddress: {
      country: { id: countryIds.czechRepublic, name: "Česká republika" },
      municipality: { id: municipalityIds.liberec, name: "Liberec" },
      municipalityId: municipalityIds.liberec,
      street: "Moskevská",
      orientationNumber: "14",
      zip: "46001",
    },
    deliveryAddress: {
      country: { id: countryIds.czechRepublic, name: "Česká republika" },
      municipality: { id: municipalityIds.praha, name: "Praha" },
      municipalityId: municipalityIds.praha,
      street: "Na Poříčním právu",
      orientationNumber: "376/1",
      zip: "12801",
    },
    permanentAddress: {
      country: { id: countryIds.czechRepublic, name: "Česká republika" },
      municipality: { id: municipalityIds.praha, name: "Praha" },
      municipalityId: municipalityIds.praha,
      street: "Korunní",
      orientationNumber: "100",
      zip: "10100",
      orp: "Praha",
    },
    permanentAddressUpdateDate: generateDate(0, -4),
    deathDate: null,
    workingPositions: [
      {
        id: "wp-008-001",
        ovmId: ovmIds.ministerstvoPrace,
        created: generateDate(3),
        workingPosition: {
          id: "position-008",
          name: "Náměstkyně ministra",
          organization: {
            id: ovmIds.ministerstvoPrace,
            name: "Ministerstvo práce a sociálních věcí",
          },
        },
        fromDate: "2022-03-01T00:00:00.000Z",
        toDate: null,
        visibility: "SECRET",
      },
    ],
    statements: [
      {
        id: "stmt-008-001",
        type: "INGOING",
        state: "ACCEPT",
        creationDate: generateDate(3),
      },
      {
        id: "stmt-008-002",
        type: "ONGOING",
        state: "ACCEPT",
        creationDate: generateDate(2),
      },
      {
        id: "stmt-008-003",
        type: "ONGOING",
        state: "ACCEPT",
        creationDate: generateDate(1),
      },
    ],
    ovms: [
      {
        id: ovmIds.ministerstvoPrace,
        name: "Ministerstvo práce a sociálních věcí",
      },
    ],
    settings: {
      mainOvm: {
        id: ovmIds.ministerstvoPrace,
        name: "Ministerstvo práce a sociálních věcí",
      },
      mainOvmName: "Ministerstvo práce a sociálních věcí",
    },
  },
  {
    id: "official-009",
    firstName: "Martin",
    middleName: "",
    lastName: "Horák",
    titleBefore: "Bc.",
    titleAfter: "",
    birthDate: generateBirthDate(32),
    email: "martin.horak@roztoky.cz",
    databox: "yza567gh",
    username: "mhorak",
    active: true,
    checked: true,
    checkedISZR: true,
    visibility: "PUBLIC",
    wpVisibility: "Veřejné",
    created: generateDate(2),
    dateOfEnd: null,
    lastStatementDate: generateDate(0, -2),
    appealDate: null,
    ovmName: "Obec Roztoky",
    archived: [],
    judge: false,
    isMy: true,
    canGeneratePassword: true,
    canDisplayCredentials: true,
    deputyOrSenator: false,
    promiseDocumented: false,
    concatenatedWorkingPositions: "Místostarosta",
    concatenatedWorkingPositionOrganizations: "Obec Roztoky",
    concatenatedWorkingPositionDates: "20.10.2022 - dosud",
    birthAddress: {
      country: { id: countryIds.czechRepublic, name: "Česká republika" },
      municipality: { id: municipalityIds.praha, name: "Praha" },
      municipalityId: municipalityIds.praha,
      street: "Čechova",
      orientationNumber: "7",
      zip: "17000",
    },
    deliveryAddress: {
      country: { id: countryIds.czechRepublic, name: "Česká republika" },
      municipality: { id: municipalityIds.roztoky, name: "Roztoky" },
      municipalityId: municipalityIds.roztoky,
      street: "Masarykova",
      orientationNumber: "1/1",
      zip: "25263",
    },
    permanentAddress: {
      country: { id: countryIds.czechRepublic, name: "Česká republika" },
      municipality: { id: municipalityIds.roztoky, name: "Roztoky" },
      municipalityId: municipalityIds.roztoky,
      street: "U Přehrady",
      orientationNumber: "28",
      zip: "25263",
      orp: "Černošice",
    },
    permanentAddressUpdateDate: generateDate(0, -5),
    deathDate: null,
    workingPositions: [
      {
        id: "wp-009-001",
        ovmId: ovmIds.obecRoztoky,
        created: generateDate(2),
        workingPosition: {
          id: "position-009",
          name: "Místostarosta",
          organization: { id: ovmIds.obecRoztoky, name: "Obec Roztoky" },
        },
        fromDate: "2022-10-20T00:00:00.000Z",
        toDate: null,
        visibility: "PUBLIC",
      },
    ],
    statements: [
      {
        id: "stmt-009-001",
        type: "INGOING",
        state: "ACCEPT",
        creationDate: generateDate(2),
      },
      {
        id: "stmt-009-002",
        type: "ONGOING",
        state: "NEW",
        creationDate: generateDate(0, -2),
      },
    ],
    ovms: [{ id: ovmIds.obecRoztoky, name: "Obec Roztoky" }],
    settings: {
      mainOvm: { id: ovmIds.obecRoztoky, name: "Obec Roztoky" },
      mainOvmName: "Obec Roztoky",
    },
  },
  {
    id: "official-010",
    firstName: "Hana",
    middleName: "",
    lastName: "Pokorná",
    titleBefore: "Ing. arch.",
    titleAfter: "",
    birthDate: generateBirthDate(50),
    email: "hana.pokorna@praha.eu",
    databox: "bcd890ef",
    username: "hpokorna",
    active: true,
    checked: true,
    checkedISZR: true,
    visibility: "PUBLIC",
    wpVisibility: "Veřejné",
    created: generateDate(4),
    dateOfEnd: null,
    lastStatementDate: generateDate(0, -1),
    appealDate: null,
    ovmName: "Magistrát hl. m. Prahy",
    archived: [],
    judge: false,
    isMy: false,
    canGeneratePassword: true,
    canDisplayCredentials: true,
    deputyOrSenator: false,
    promiseDocumented: false,
    concatenatedWorkingPositions: "Radní pro územní rozvoj",
    concatenatedWorkingPositionOrganizations: "Magistrát hl. m. Prahy",
    concatenatedWorkingPositionDates: "15.11.2022 - dosud",
    birthAddress: {
      country: { id: countryIds.czechRepublic, name: "Česká republika" },
      municipality: { id: municipalityIds.praha, name: "Praha" },
      municipalityId: municipalityIds.praha,
      street: "Na Příkopě",
      orientationNumber: "33",
      zip: "11000",
    },
    deliveryAddress: {
      country: { id: countryIds.czechRepublic, name: "Česká republika" },
      municipality: { id: municipalityIds.praha, name: "Praha" },
      municipalityId: municipalityIds.praha,
      street: "Mariánské náměstí",
      orientationNumber: "2/2",
      zip: "11001",
    },
    permanentAddress: {
      country: { id: countryIds.czechRepublic, name: "Česká republika" },
      municipality: { id: municipalityIds.praha, name: "Praha" },
      municipalityId: municipalityIds.praha,
      street: "Francouzská",
      orientationNumber: "75",
      zip: "10100",
      orp: "Praha",
    },
    permanentAddressUpdateDate: generateDate(0, -3),
    deathDate: null,
    workingPositions: [
      {
        id: "wp-010-001",
        ovmId: ovmIds.mestoPraha,
        created: generateDate(1, 2),
        workingPosition: {
          id: "position-010",
          name: "Radní pro územní rozvoj",
          organization: {
            id: ovmIds.mestoPraha,
            name: "Magistrát hl. m. Prahy",
          },
        },
        fromDate: "2022-11-15T00:00:00.000Z",
        toDate: null,
        visibility: "PUBLIC",
      },
    ],
    statements: [
      {
        id: "stmt-010-001",
        type: "INGOING",
        state: "ACCEPT",
        creationDate: generateDate(1, 2),
      },
      {
        id: "stmt-010-002",
        type: "ONGOING",
        state: "ACCEPT",
        creationDate: generateDate(0, -1),
      },
    ],
    ovms: [{ id: ovmIds.mestoPraha, name: "Magistrát hl. m. Prahy" }],
    settings: {
      mainOvm: { id: ovmIds.mestoPraha, name: "Magistrát hl. m. Prahy" },
      mainOvmName: "Magistrát hl. m. Prahy",
    },
  },
  {
    id: "official-011",
    firstName: "Jiří",
    middleName: "",
    lastName: "Kolář",
    titleBefore: "doc. JUDr.",
    titleAfter: "CSc.",
    birthDate: generateBirthDate(58),
    email: "jiri.kolar@senat.cz",
    databox: "efg123ab",
    username: "jkolar",
    active: true,
    checked: true,
    checkedISZR: true,
    visibility: "PUBLIC",
    wpVisibility: "Veřejné",
    created: generateDate(7),
    dateOfEnd: null,
    lastStatementDate: generateDate(0, -2),
    appealDate: null,
    ovmName: "Senát ČR",
    archived: [],
    judge: false,
    isMy: true,
    canGeneratePassword: true,
    canDisplayCredentials: true,
    deputyOrSenator: true,
    senator: true,
    senatorAndOthers: true,
    promiseDocumented: true,
    concatenatedWorkingPositions: "Senátor, Předseda výboru",
    concatenatedWorkingPositionOrganizations: "Senát ČR",
    concatenatedWorkingPositionDates: "01.11.2016 - dosud",
    birthAddress: {
      country: { id: countryIds.czechRepublic, name: "Česká republika" },
      municipality: { id: municipalityIds.ostrava, name: "Ostrava" },
      municipalityId: municipalityIds.ostrava,
      street: "28. října",
      orientationNumber: "150",
      zip: "70200",
    },
    deliveryAddress: {
      country: { id: countryIds.czechRepublic, name: "Česká republika" },
      municipality: { id: municipalityIds.praha, name: "Praha" },
      municipalityId: municipalityIds.praha,
      street: "Valdštejnské náměstí",
      orientationNumber: "17/4",
      zip: "11800",
    },
    permanentAddress: {
      country: { id: countryIds.czechRepublic, name: "Česká republika" },
      municipality: { id: municipalityIds.ostrava, name: "Ostrava" },
      municipalityId: municipalityIds.ostrava,
      street: "Českobratrská",
      orientationNumber: "22",
      zip: "70200",
      orp: "Ostrava",
    },
    permanentAddressUpdateDate: generateDate(1),
    deathDate: null,
    workingPositions: [
      {
        id: "wp-011-001",
        ovmId: ovmIds.senat,
        created: generateDate(7),
        workingPosition: {
          id: "position-011",
          name: "Senátor",
          organization: { id: ovmIds.senat, name: "Senát ČR" },
        },
        fromDate: "2016-11-01T00:00:00.000Z",
        toDate: null,
        visibility: "PUBLIC",
      },
      {
        id: "wp-011-002",
        ovmId: ovmIds.senat,
        created: generateDate(5),
        workingPosition: {
          id: "position-012",
          name: "Předseda výboru",
          organization: { id: ovmIds.senat, name: "Senát ČR" },
        },
        fromDate: "2018-11-01T00:00:00.000Z",
        toDate: null,
        visibility: "PUBLIC",
      },
    ],
    statements: [
      {
        id: "stmt-011-001",
        type: "POINT3",
        state: "ACCEPT",
        creationDate: generateDate(7),
      },
      {
        id: "stmt-011-002",
        type: "ONGOING",
        state: "ACCEPT",
        creationDate: generateDate(6),
      },
      {
        id: "stmt-011-003",
        type: "ONGOING",
        state: "ACCEPT",
        creationDate: generateDate(5),
      },
      {
        id: "stmt-011-004",
        type: "ONGOING",
        state: "ACCEPT",
        creationDate: generateDate(4),
      },
      {
        id: "stmt-011-005",
        type: "ONGOING",
        state: "ACCEPT",
        creationDate: generateDate(3),
      },
      {
        id: "stmt-011-006",
        type: "ONGOING",
        state: "ACCEPT",
        creationDate: generateDate(2),
      },
      {
        id: "stmt-011-007",
        type: "ONGOING",
        state: "ACCEPT",
        creationDate: generateDate(1),
      },
    ],
    ovms: [{ id: ovmIds.senat, name: "Senát ČR" }],
    settings: {
      mainOvm: { id: ovmIds.senat, name: "Senát ČR" },
      mainOvmName: "Senát ČR",
    },
  },
  {
    id: "official-012",
    firstName: "Petra",
    middleName: "Jana",
    lastName: "Němcová",
    titleBefore: "RNDr.",
    titleAfter: "Ph.D.",
    birthDate: generateBirthDate(41),
    email: "petra.nemcova@mfin.cz",
    databox: "hij456cd",
    username: "pnemcova",
    active: true,
    checked: true,
    checkedISZR: true,
    visibility: "REQUEST",
    wpVisibility: "Na žádost",
    created: generateDate(2),
    dateOfEnd: null,
    lastStatementDate: generateDate(0, -3),
    appealDate: null,
    ovmName: "Ministerstvo financí",
    archived: [],
    judge: false,
    isMy: true,
    canGeneratePassword: true,
    canDisplayCredentials: true,
    deputyOrSenator: false,
    promiseDocumented: false,
    concatenatedWorkingPositions: "Ředitelka odboru",
    concatenatedWorkingPositionOrganizations: "Ministerstvo financí",
    concatenatedWorkingPositionDates: "01.06.2023 - dosud",
    birthAddress: {
      country: { id: countryIds.slovakia, name: "Slovensko" },
      municipality: null,
      municipalityId: null,
      street: "Hlavná",
      orientationNumber: "15",
      zip: "81101",
      city: "Bratislava",
    },
    deliveryAddress: {
      country: { id: countryIds.czechRepublic, name: "Česká republika" },
      municipality: { id: municipalityIds.praha, name: "Praha" },
      municipalityId: municipalityIds.praha,
      street: "Letenská",
      orientationNumber: "525/15",
      zip: "11800",
    },
    permanentAddress: {
      country: { id: countryIds.czechRepublic, name: "Česká republika" },
      municipality: { id: municipalityIds.praha, name: "Praha" },
      municipalityId: municipalityIds.praha,
      street: "Dejvická",
      orientationNumber: "50",
      zip: "16000",
      orp: "Praha",
    },
    permanentAddressUpdateDate: generateDate(0, -8),
    deathDate: null,
    workingPositions: [
      {
        id: "wp-012-001",
        ovmId: ovmIds.ministerstvo,
        created: generateDate(1, 6),
        workingPosition: {
          id: "position-013",
          name: "Ředitelka odboru",
          organization: {
            id: ovmIds.ministerstvo,
            name: "Ministerstvo financí",
          },
        },
        fromDate: "2023-06-01T00:00:00.000Z",
        toDate: null,
        visibility: "REQUEST",
      },
    ],
    statements: [
      {
        id: "stmt-012-001",
        type: "INGOING",
        state: "ACCEPT",
        creationDate: generateDate(1, 6),
      },
      {
        id: "stmt-012-002",
        type: "ONGOING",
        state: "INCOMPLETE",
        creationDate: generateDate(0, -3),
      },
    ],
    ovms: [{ id: ovmIds.ministerstvo, name: "Ministerstvo financí" }],
    settings: {
      mainOvm: { id: ovmIds.ministerstvo, name: "Ministerstvo financí" },
      mainOvmName: "Ministerstvo financí",
    },
  },
  {
    id: "official-013",
    firstName: "Vladimír",
    middleName: "",
    lastName: "Starý",
    titleBefore: "",
    titleAfter: "",
    birthDate: generateBirthDate(67),
    email: "vladimir.stary@brno.cz",
    databox: "klm789ef",
    username: "vstary",
    active: false,
    checked: true,
    checkedISZR: true,
    visibility: "PUBLIC",
    wpVisibility: "Veřejné",
    created: generateDate(10),
    dateOfEnd: generateDate(2),
    lastStatementDate: generateDate(2, 1),
    appealDate: null,
    ovmName: "Statutární město Brno",
    archived: ["2024-01-15T00:00:00.000Z"],
    judge: false,
    isMy: true,
    canGeneratePassword: false,
    canDisplayCredentials: true,
    deputyOrSenator: false,
    promiseDocumented: false,
    concatenatedWorkingPositions: "Radní",
    concatenatedWorkingPositionOrganizations: "Statutární město Brno",
    concatenatedWorkingPositionDates: "01.11.2014 - 31.10.2022",
    birthAddress: {
      country: { id: countryIds.czechRepublic, name: "Česká republika" },
      municipality: { id: municipalityIds.brno, name: "Brno" },
      municipalityId: municipalityIds.brno,
      street: "Pekařská",
      orientationNumber: "45",
      zip: "60200",
    },
    deliveryAddress: {
      country: { id: countryIds.czechRepublic, name: "Česká republika" },
      municipality: { id: municipalityIds.brno, name: "Brno" },
      municipalityId: municipalityIds.brno,
      street: "Dominikánské náměstí",
      orientationNumber: "196/1",
      zip: "60167",
    },
    permanentAddress: {
      country: { id: countryIds.czechRepublic, name: "Česká republika" },
      municipality: { id: municipalityIds.brno, name: "Brno" },
      municipalityId: municipalityIds.brno,
      street: "Hrnčířská",
      orientationNumber: "8",
      zip: "60200",
      orp: "Brno",
    },
    permanentAddressUpdateDate: generateDate(3),
    deathDate: null,
    workingPositions: [
      {
        id: "wp-013-001",
        ovmId: ovmIds.mestoBrno,
        created: generateDate(10),
        workingPosition: {
          id: "position-014",
          name: "Radní",
          organization: { id: ovmIds.mestoBrno, name: "Statutární město Brno" },
        },
        fromDate: "2014-11-01T00:00:00.000Z",
        toDate: "2022-10-31T00:00:00.000Z",
        visibility: "PUBLIC",
      },
    ],
    statements: [
      {
        id: "stmt-013-001",
        type: "INGOING",
        state: "ACCEPT",
        creationDate: generateDate(10),
      },
      {
        id: "stmt-013-002",
        type: "ONGOING",
        state: "ACCEPT",
        creationDate: generateDate(9),
      },
      {
        id: "stmt-013-003",
        type: "ONGOING",
        state: "ACCEPT",
        creationDate: generateDate(8),
      },
      {
        id: "stmt-013-004",
        type: "ONGOING",
        state: "ACCEPT",
        creationDate: generateDate(7),
      },
      {
        id: "stmt-013-005",
        type: "ONGOING",
        state: "ACCEPT",
        creationDate: generateDate(6),
      },
      {
        id: "stmt-013-006",
        type: "ONGOING",
        state: "ACCEPT",
        creationDate: generateDate(5),
      },
      {
        id: "stmt-013-007",
        type: "ONGOING",
        state: "ACCEPT",
        creationDate: generateDate(4),
      },
      {
        id: "stmt-013-008",
        type: "ONGOING",
        state: "ACCEPT",
        creationDate: generateDate(3),
      },
      {
        id: "stmt-013-009",
        type: "OUTGOING",
        state: "ACCEPT",
        creationDate: generateDate(2, 1),
      },
    ],
    ovms: [{ id: ovmIds.mestoBrno, name: "Statutární město Brno" }],
    settings: {
      mainOvm: { id: ovmIds.mestoBrno, name: "Statutární město Brno" },
      mainOvmName: "Statutární město Brno",
    },
  },
  {
    id: "official-014",
    firstName: "Daniela",
    middleName: "",
    lastName: "Fialová",
    titleBefore: "Mgr.",
    titleAfter: "",
    birthDate: generateBirthDate(37),
    email: "daniela.fialova@psp.cz",
    databox: "nop012gh",
    username: "dfialova",
    active: true,
    checked: false,
    checkedISZR: false,
    visibility: "PUBLIC",
    wpVisibility: "Veřejné",
    created: generateDate(0, -8),
    dateOfEnd: null,
    lastStatementDate: null,
    appealDate: generateDate(0, -2),
    ovmName: "Poslanecká sněmovna",
    archived: [],
    judge: false,
    isMy: true,
    canGeneratePassword: true,
    canDisplayCredentials: true,
    deputyOrSenator: true,
    deputy: true,
    deputyAndOthers: false,
    promiseDocumented: false,
    concatenatedWorkingPositions: "Poslankyně",
    concatenatedWorkingPositionOrganizations: "Poslanecká sněmovna",
    concatenatedWorkingPositionDates: "08.11.2025 - dosud",
    birthAddress: {
      country: { id: countryIds.czechRepublic, name: "Česká republika" },
      municipality: { id: municipalityIds.plzen, name: "Plzeň" },
      municipalityId: municipalityIds.plzen,
      street: "Klatovská",
      orientationNumber: "110",
      zip: "30100",
    },
    deliveryAddress: {
      country: { id: countryIds.czechRepublic, name: "Česká republika" },
      municipality: { id: municipalityIds.praha, name: "Praha" },
      municipalityId: municipalityIds.praha,
      street: "Sněmovní",
      orientationNumber: "176/4",
      zip: "11800",
    },
    permanentAddress: {
      country: { id: countryIds.czechRepublic, name: "Česká republika" },
      municipality: { id: municipalityIds.plzen, name: "Plzeň" },
      municipalityId: municipalityIds.plzen,
      street: "Tylova",
      orientationNumber: "18",
      zip: "30100",
      orp: "Plzeň",
    },
    permanentAddressUpdateDate: generateDate(0, -7),
    deathDate: null,
    workingPositions: [
      {
        id: "wp-014-001",
        ovmId: ovmIds.snemovna,
        created: generateDate(0, -8),
        workingPosition: {
          id: "position-015",
          name: "Poslankyně",
          organization: { id: ovmIds.snemovna, name: "Poslanecká sněmovna" },
        },
        fromDate: "2025-11-08T00:00:00.000Z",
        toDate: null,
        visibility: "PUBLIC",
      },
    ],
    statements: [],
    ovms: [{ id: ovmIds.snemovna, name: "Poslanecká sněmovna" }],
    settings: {
      mainOvm: { id: ovmIds.snemovna, name: "Poslanecká sněmovna" },
      mainOvmName: "Poslanecká sněmovna",
    },
  },
  {
    id: "official-015",
    firstName: "Ondřej",
    middleName: "",
    lastName: "Beneš",
    titleBefore: "Ing.",
    titleAfter: "",
    birthDate: generateBirthDate(43),
    email: "ondrej.benes@kraj-jm.cz",
    databox: "qrs345ij",
    username: "obenes",
    active: true,
    checked: true,
    checkedISZR: true,
    visibility: "PUBLIC",
    wpVisibility: "Veřejné",
    created: generateDate(0, -4),
    dateOfEnd: null,
    lastStatementDate: null,
    appealDate: null,
    ovmName: "Jihomoravský kraj",
    archived: [],
    judge: false,
    isMy: true,
    canGeneratePassword: true,
    canDisplayCredentials: true,
    deputyOrSenator: false,
    promiseDocumented: false,
    concatenatedWorkingPositions: "Hejtman",
    concatenatedWorkingPositionOrganizations: "Jihomoravský kraj",
    concatenatedWorkingPositionDates: "01.07.2025 - dosud",
    birthAddress: {
      country: { id: countryIds.czechRepublic, name: "Česká republika" },
      municipality: { id: municipalityIds.brno, name: "Brno" },
      municipalityId: municipalityIds.brno,
      street: "Veveří",
      orientationNumber: "70",
      zip: "60200",
    },
    deliveryAddress: {
      country: { id: countryIds.czechRepublic, name: "Česká republika" },
      municipality: { id: municipalityIds.brno, name: "Brno" },
      municipalityId: municipalityIds.brno,
      street: "Žerotínovo náměstí",
      orientationNumber: "449/3",
      zip: "60182",
    },
    permanentAddress: {
      country: { id: countryIds.czechRepublic, name: "Česká republika" },
      municipality: { id: municipalityIds.brno, name: "Brno" },
      municipalityId: municipalityIds.brno,
      street: "Grohova",
      orientationNumber: "55",
      zip: "60200",
      orp: "Brno",
    },
    permanentAddressUpdateDate: generateDate(0, -3),
    deathDate: null,
    workingPositions: [
      {
        id: "wp-015-001",
        ovmId: ovmIds.krajBrno,
        created: generateDate(0, -4),
        workingPosition: {
          id: "position-016",
          name: "Hejtman",
          organization: { id: ovmIds.krajBrno, name: "Jihomoravský kraj" },
        },
        fromDate: "2025-07-01T00:00:00.000Z",
        toDate: null,
        visibility: "PUBLIC",
      },
    ],
    statements: [
      {
        id: "stmt-015-001",
        type: "INGOING",
        state: "NEW",
        creationDate: generateDate(0, -3),
      },
    ],
    ovms: [{ id: ovmIds.krajBrno, name: "Jihomoravský kraj" }],
    settings: {
      mainOvm: { id: ovmIds.krajBrno, name: "Jihomoravský kraj" },
      mainOvmName: "Jihomoravský kraj",
    },
  },
];

// Export pomocných konštánt
export { ovmIds, countryIds, municipalityIds };

export default officials;
